<template>
  <VueMap
    :id="'group-map'"
    v-model:coordinate="coordinate"
    v-model:zoom="zoom"
  >
    <VueMapDraggableMarker
      v-model:coordinate="groupCoordinate"
      :marker-style="MapMarkerStyle.group"
      @marker-move="onMarkerMoved"
    />
  </VueMap>
</template>
<script lang="ts" setup>
  import VueMap from '@/VueComponents/SharedComponents/Map/VueMap.vue';
  import { Ref } from 'vue';
  import MapCoordinate from '@/Types/mapCoordinate';
  import VueMapDraggableMarker from '@/VueComponents/SharedComponents/Map/VueMapDraggableMarker.vue';
  import { MapMarkerStyle } from '@/VueComponents/SharedComponents/Map/Models/mapMarkerStyle';

  const coordinate: Ref<MapCoordinate> = defineModel<MapCoordinate>('coordinate', { required: true });
  const groupCoordinate: Ref<MapCoordinate> = defineModel<MapCoordinate>('groupCoordinate', { required: true });
  const zoom: Ref<number> = defineModel<number>('zoom', { required: true });

</script>